import React from 'react';
import DashboardLayout from './DashboardLayout';

const DashboardFavorites = () => (
  <DashboardLayout>
    <div>
      <h2>Favorites</h2>
      <p>See your favorited businesses here.</p>
      {/* Favorites list component goes here */}
    </div>
  </DashboardLayout>
);

export default DashboardFavorites; 